import { render, staticRenderFns } from "./Holder.vue?vue&type=template&id=13ab3320&"
import script from "./Holder.vue?vue&type=script&lang=js&"
export * from "./Holder.vue?vue&type=script&lang=js&"
import style0 from "./Holder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports